import api from './api';
import { mapProductDto, toProductPayload } from '../dto/ProductDTO';

// Product catalogue — the sellable items a deal's positions can reference.

export const getAllProducts = ({ includeInactive = false } = {}) =>
    api.get('/Product', { params: { include_inactive: includeInactive } })
        .then(res => res.data.map(mapProductDto));

export const getProduct = (productId) =>
    api.get(`/Product/${productId}`).then(res => mapProductDto(res.data));

export const addProduct = (product) =>
    api.post('/Product', toProductPayload(product)).then(res => res.data);

export const patchProduct = (productId, product) =>
    api.patch(`/Product/${productId}`, toProductPayload(product)).then(res => res.data);

export const setProductActive = (productId, isActive) =>
    api.patch(`/Product/${productId}`, { is_active: isActive }).then(res => res.data);

export const deleteProduct = (productId) =>
    api.delete(`/Product/${productId}`).then(res => res.data);
